import React, { useContext, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import MaskingEditor from './MaskingEditor';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { FaPlug } from "react-icons/fa";
import DiscoveryTooltip from 'DiscoveryTooltip';
import { FaTrashAlt, FaSave } from 'react-icons/fa';
// import { useParams } from 'react-router';
import { IntegrationContext } from '../Utils';
import { Button, Spinner } from 'react-bootstrap';


import Select from 'react-select';
import {
  customFilter,
  getReactSelectOption,
  Input,
  Option,
  SingleValue
} from 'Integrations/Utils';

// const defaultType = 'MASK';

// const options = [
//   { value: 'MASK', label: 'Masking' },
//   { value: 'ENCRYPT', label: 'Encryption' },
//   { value: 'REDACT', label: 'Redaction' },
//   { value: 'SYNTHESIZE', label: 'Synthesis' },
// ]


const IntegrationForm = ({ saveIntegrationHandler, deleteIntegrationHandler, testConnectionHandler, engineOptions, currentState}) => {
  const { id } = useParams();
  // const location = useLocation();

  
  const [integration, setIntegration] = useState(currentState);


  let slectedEngineOption = (engineOptions.length > 0) ? engineOptions[0] : null;
  const currentEngineCode = (integration && integration.enginecode) ? integration.enginecode : slectedEngineOption;

  const selectedEngineOption = getReactSelectOption(currentEngineCode, engineOptions);

  const formProps = {
    type: integration.type,
    integration: integration,
    setIntegration: (v) => {
      // setUnsavedChanges(true);
      // setConnection(v);
    },
  };

  return (
    <Card className='shadow-sm widget-card'>
      <div className='widget-header p-3 text-left'>
        <FaPlug className='widget-header-icon mr-2' />Integration Data Source
      </div>
      <Card.Body>
        <Form
          autoComplete='new-password'
          onSubmit={async (e) =>{
            e.preventDefault();
            await saveIntegrationHandler(integration)
          }}
        >
          <Row className='text-left'>
            <Col>
              {/* <Form.Group>
                <Form.Label for="select-source-dropdown" className="start-search-labels">
                  Integration Type
                </Form.Label>
                <Select
                  components={{ SingleValue, Input, Option }}
                  options={options}
                  value={selectedOption}
                  defaultValue={options[3]}
                  onChange={(obj) => {
                    setIntegration({ ...integration, type: obj.value });
                  }}
                  filterOption={customFilter}
                  isDisabled={id}
                />
                <Form.Text className='mt-3'>* Required fields</Form.Text>
              </Form.Group> */}
              <Form.Group>
                <Form.Label for="select-source-dropdown" className="start-search-labels">
                  Integration Engine
                </Form.Label>
                <div data-testid="integration-engine-select">
                <Select
                  components={{ SingleValue, Input, Option }}
                  options={engineOptions}
                  value={selectedEngineOption}
                  defaultValue={engineOptions[0]}
                  onChange={(obj) => {
                    // console.log('IntegrationForm onChange', obj);
                    setIntegration({ ...integration, enginetype: obj.type, enginecode: obj.value });
                  }}
                  filterOption={customFilter}
                  isDisabled={id}
                />
                </div>
                <Form.Text className='mt-3'>* Required fields</Form.Text>
              </Form.Group>
            </Col>
          </Row>
            <MaskingEditor integration={integration} setIntegration={setIntegration} />
          <FormButtons
            deleteIntegrationHandler={deleteIntegrationHandler}
            saveIntegrationHandler={saveIntegrationHandler}
            integration={integration}
            testConnectionHandler={testConnectionHandler}
            // currentState={currentState}
            // saving={saving}
          />
        </Form>
      </Card.Body>
    </Card>
  );
}


const FormButtons = ({ integration, deleteIntegrationHandler, saveIntegrationHandler, testConnectionHandler, currentState, saving }) => {
  const { id } = useParams();
  // console.log('FormButtons', integration);
  return (
    <Row className='mt-5 justify-content-end'>
      {id &&
        <div className='pr-1'>
          <Button
            disabled={integration.id === -1}
            className='w-100'
            onClick={async () => await deleteIntegrationHandler(integration)}
            variant='outline-light'
          >
            {currentState === 'deleting' ? (
              <Spinner
                className='mr-2'
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
              />
            ) : (
              <FaTrashAlt className='mr-2' />
            )}
            DELETE
          </Button>
        </div>}
      <div className={id && 'pl-1'}>
        <DiscoveryTooltip
          placement='right'
          text='Test the integration Data Source'
        >
          <Button
            className='w-100'
            variant='outline-primary'
            disabled={currentState === 'testing'}
            onClick={async () => await testConnectionHandler(integration)}
          >
            {currentState === 'testing' ? (
              <Spinner
                className='mr-2'
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
              />
            ) : (
              <FaPlug className='mr-2' />
            )}
            TEST
          </Button>
        </DiscoveryTooltip>
      </div>
      <div className='pl-1'>
        <DiscoveryTooltip
          placement='right'
          text={id ? 'Update integration details.' : 'Save your integration'}
        >
          <Button
            className='w-100'
            variant='primary primary'
            disabled={saving}
            onClick={async () => {  }}
            type='submit'
          >
            {saving ? (
              <Spinner
                className='mr-2'
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
              />
            ) : (
              <FaSave className='mr-2' />
            )}
            SAVE
          </Button>
        </DiscoveryTooltip>
      </div>
    </Row>
  )
}
export default IntegrationForm;